import React, { Component } from 'react';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2'
import axios from 'axios';
import Global from '../Global';
const MySwal = withReactContent(Swal)
const api = Global.api

class Solicitud extends Component {
    swal_success(id) {
        return MySwal.fire({
            html: (
                <div>
                    <h1>¡ÉXITO!</h1>
                    <h5>Tu solicitud fue enviada con éxito</h5>
                    <span>Esta es tu clave de seguimiento</span>
                    <br />
                    <div className='input-group mb-3 mt-3'>
                        <input type='text' className='form-control' aria-describedby='basic-addon2' value={id} readOnly></input>
                        <div className='input-group-append'>
                            <button onClick={() => this.copyIdToClipboard(id)} className='btn btn-outline-primary' type='button'>
                                <i className='fas fa-copy'></i>
                            </button>
                        </div>
                    </div>
                    <span style={{ fontSize: 0.8 + 'em' }}>Esta clave te fue enviada por correo, asegúrate de revisar tus <strong>correos no deseados y la bandeja de spam</strong></span>
                </div>),
            icon: 'success',
            allowOutsideClick: false
        }).then(() => {
            window.location = "/solicitudes";
        })
    }

    swal_error(title, text) {
        return MySwal.fire({
            title: title,
            text: text,
            icon: 'error',
            allowOutsideClick: false
        })
    }

    swal_warning(title, text) {
        return MySwal.fire({
            title: title,
            text: text,
            icon: 'warning',
            allowOutsideClick: false
        })
    }

    fallbackCopyIdToClipboard = (id) => {
        var textArea = document.createElement("textarea");
        textArea.value = id;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            console.log(successful);
            console.log('Fallback: Copying to clipboard was successful!');
        } catch (err) {
            console.error('Fallback: Could not copy text: ', err);
        }
        document.body.removeChild(textArea);
    }

    copyIdToClipboard = (id) => {
        try {
            navigator.clipboard.writeText(id).then(function () {
                console.log('Async: Copying to clipboard was successful!');
            }, function (err) {
                console.error('Async: Could not copy text: ', err);
            });
        }
        catch {
            this.fallbackCopyIdToClipboard(id);
        }
        finally {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });

            Toast.fire({
                icon: 'success',
                title: 'Copiado al portapapeles'
            }).then(() => {
                window.location = "/solicitudes";
            });
        }
    }

    state = {
        form: {},
        status: null,
        filesUploaded: []
    }

    formFields = null
    renderInputList = null

    nombre = React.createRef()
    apellido_paterno = React.createRef()
    apellido_materno = React.createRef()
    email = React.createRef()
    telefono = React.createRef()
    expediente = React.createRef()

    componentWillMount() {
        this.getForm(this.props.match.params.id)
    }

    getForm = (id) => {
        axios.get(api + "/forms/" + id)
            .then(res => {
                this.renderInputFileList(res.data.form_doc)
                this.setState({
                    form: res.data,
                    status: res.status
                })
            });
    }

    buildFields = () => {
        this.formFields = this.state.form.formFields.map(() => {
            return true;
        })
    }

    submitSubmission = (e) => {
        e.preventDefault();
        if (this.validateFields()) {
            if (this.validateFiles()) {
                let form_fields = [
                    {
                        nombre: this.nombre.current.value,
                        apellido_paterno: this.apellido_paterno.current.value,
                        apellido_materno: this.apellido_materno.current.value,
                        email: this.email.current.value,
                        telefono: this.telefono.current.value
                    }
                ]

                let submission = new FormData()
                submission.append('form_id', this.props.match.params.id)
                submission.append('form_name', this.state.form.form_name)
                submission.append('sub_type', this.state.form.form_type)
                submission.append('sub_desc', this.state.form.form_type)
                submission.append('sub_values', JSON.stringify(form_fields));
                for (let i = 0; i < this.state.filesUploaded.length; i++) {
                    submission.append('sub_docs', this.state.filesUploaded[i])
                }
                axios.post(api + '/submissions/', submission)
                    .then((res) => {
                        if (res.data.id) {
                            this.swal_success(res.data.id);
                        } else {
                            this.swal_error('Oops...', 'Algo salió mal, inténtalo más tarde');
                        }
                    })
                    .catch(() => {
                        this.swal_error('Oops...', 'Algo salió mal, inténtalo más tarde');
                    });
            } else {
                this.swal_error('Oops...', 'Necesitas subir los archivos necesarios');
            }
        } else {
            this.swal_error('Oops...', 'Necesitas llenar todos los campos');
        }
    }

    validateFields = () => {
        if (this.nombre.current.value !== '' && this.apellido_paterno.current.value !== ''
            && this.apellido_materno.current.value !== ''
            && this.email.current.value !== ''
            && this.telefono.current.value !== '') {
            return true
        }
        return false;
    }

    fileChange = (e, index) => {
        const array = this.state.filesUploaded;
        array[index] = e.target.files[0];
        this.setState({
            filesUploaded: array
        })
    }

    validateFiles = () => {
        if(this.state.filesUploaded.length < this.state.form.form_doc.length) {
            return false
        }
        for (let i = 0; i < this.state.filesUploaded.length; i++) {
            if(this.state.filesUploaded[i] === undefined || this.state.filesUploaded[i] === '') {
                return false
            }
        }
        return true;
    }

    renderInputFileList = (inputFileList) => {
        this.renderInputList = inputFileList.map((field, index) => {
            return (
                <div key={field.name} className="fields col-lg-4 col-md-6 col-sm-12">
                    <label>{field.title}</label>
                    <input onChange={(e) => this.fileChange(e, index)} type="file" className="form-control"></input>
                </div>
            )
        })
    }

    render() {
        let form_desc = this.state.form.form_desc;

        if (this.state.form.form_desc) {
            const form_desc_parts = this.state.form.form_desc.split(':');

            if (form_desc_parts.length > 2) {
                form_desc = <><>{form_desc_parts[0] + ": "}</> <a href={form_desc_parts[1] + ':' + form_desc_parts[2]} target="_blank" rel="noreferrer">solicitud</a></>
            }
        }
        return (
            <div>
                <div className="solicitudes_container">
                    <div className="row">
                        <div className="col-lg-1 col-md-1"></div>
                        <div className="col-lg-8 col-md-8 col-sm-7 col-12">
                            <div className="row">
                                <div className="col-12">
                                    <span className="breadcrumbs"><a href="/solicitudes">Home </a> / <a href="/solicitudes/tramites"> Trámites</a></span>
                                </div>
                                {/* <div className="col-12">
                                    <br/>
                                    <a href="/tramites" className="btn btn-warning btn-sm">Regresar</a>
                                </div> */}
                                <div className="col-12">
                                    <br />
                                    <h1>{this.state.form.form_name}</h1>
                                </div>
                                <div className="col-12">
                                    <span>{form_desc}</span>
                                </div>
                                <div className="col-12">
                                    <br /><br />
                                    <h4>Datos necesarios</h4>
                                    <br />
                                    <div className="row">
                                        <div className="fields col-lg-4 col-md-6 col-sm-12">
                                            <label>Nombre(s)</label>
                                            <input type="text" className="form-control" ref={this.nombre}></input>
                                        </div>
                                        <div className="fields col-lg-4 col-md-6 col-sm-12">
                                            <label>Apellido Paterno</label>
                                            <input type="text" className="form-control" ref={this.apellido_paterno}></input>
                                        </div>
                                        <div className="fields col-lg-4 col-md-6 col-sm-12">
                                            <label>Apellido Materno</label>
                                            <input type="text" className="form-control" ref={this.apellido_materno}></input>
                                        </div>
                                        <div className="fields col-lg-4 col-md-6 col-sm-12">
                                            <label>Email</label>
                                            <input type="email" className="form-control" ref={this.email}></input>
                                        </div>
                                        <div className="fields col-lg-4 col-md-6 col-sm-12">
                                            <label>Teléfono</label>
                                            <input type="text" className="form-control" ref={this.telefono}></input>
                                        </div>
                                    </div>
                                    <br /><br />
                                    <h4>Documentos necesarios</h4>
                                    <br />
                                    <div className="row">
                                        {this.renderInputList}
                                    </div>
                                </div>
                                <div className="col-md-12"><br /><br /><br />
                                    <button className="btn btn-success" onClick={this.submitSubmission}>Realizar solicitud</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-5"></div>
                        <div className="col-lg-1 col-md-1"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Solicitud;